module.exports = __webpack_public_path__ + "img/amusement-pack.468455e2.jpg";